module.exports = __webpack_public_path__ + "media/landing_page/bank-8be61c11.svg";